import React from 'react';
import InviteParticipantButton from '../../../../../elements/InviteParticipantButton';
import TopBarEvent from '../../../../../elements/TopBar/TopBarEvent';
import UserName from '../../../../../elements/UserName/UserName';
import UserAvatar from '../../../../../elements/icons/UserAvatar/UserAvatar';
import styles from './ChatRoomTopBar.module.scss';

function ChatRoomTopBar(props) {
    const { event, otherParticipant } = props,
        Tag = event ? TopBarEvent : TopBar;

    return (
        <>
            <Tag event={event}>
                <div className={styles.wrapper}>
                    <UserAvatar className={styles.avatar} user={otherParticipant} />
                    <UserName user={otherParticipant} />
                </div>
            </Tag>
            <div className={styles.inviteTop}>
                <InviteParticipantButton event={event} participant={otherParticipant} />
            </div>
        </>
    );
}

export default ChatRoomTopBar;
